const appStart = () => {
  // Sidebar scrolling functionality
  const sidebarWrapper = document.querySelector('.left-sidebar-wrapper');
  const sidebar = document.querySelector('.single-left-sidebar');
  const layout = document.querySelector('.single-post-layout'); // Parent layout container

  const menuHeight = 140; // Adjust this value to match your menu height

  const handleScroll = () => {
    const layoutRect = layout.getBoundingClientRect();
    const sidebarHeight = sidebar.offsetHeight;

    // Calculate the offset of the wrapper relative to the viewport
    const offsetTop = layoutRect.top - menuHeight; // Adjust for menu height
    const maxScroll = layoutRect.height - sidebarHeight; // Maximum allowable scroll

    if (offsetTop < 0 && Math.abs(offsetTop) < maxScroll) {
      // Move the sidebar within the wrapper
      sidebar.style.transform = `translateY(${Math.abs(offsetTop)}px)`;
    } else if (offsetTop >= 0) {
      // Reset to the top
      sidebar.style.transform = 'translateY(0)';
    } else if (Math.abs(offsetTop) >= maxScroll) {
      // Stick to the bottom
      sidebar.style.transform = `translateY(${maxScroll}px)`;
    }
  };

  const handleResize = () => {
    if (window.innerWidth >= 1024) {
      // Activate scroll functionality for wide viewports
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Ensure it runs on resize
    } else {
      // Disable scrolling behavior and reset sidebar styles
      window.removeEventListener('scroll', handleScroll);
      sidebar.style.transform = ''; // Reset the transform
    }
  };

  if (sidebarWrapper && sidebar && layout) {
    handleResize(); // Apply on page load
    window.addEventListener('resize', handleResize); // Reapply on viewport change
  }
};

// 'DOMContentLoaded' may fire before your script has a chance to run.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', appStart);
} else {
  appStart();
}
